import React, { useState } from "react";

import Header from "./header";
import "../App.css"; // Adjust the import path as necessary
import "../NewLandingPage.css";
import Footer from "./footer"; // Adjust the import path as necessary
import BackgroundImage from "../assests/home-banner.webp";
import Secondimage from "../assests/kalu-white.png";
import rightSideImage from "../assests/Untitled design (60).png";
import facebook from "../assests/facebook.png";
import instagram from "../assests/instagram.png";
import email from "../assests/email.png";
import twitter from "../assests/twitter.png";
import * as yup from "yup";
import CloseIcon from "@mui/icons-material/Close";

// Adjust the import path as necessary
import Button from "@mui/material/Button";
import {
  Grid,
  Alert,
  AlertTitle,
  Dialog,
  DialogContent,
  MenuItem,
} from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

import mainImage from "../assests/Untitled design (96).jpg";
import { useFormik } from "formik";
import { apiData } from "../services/api-methods";
import API from "../APIUrls";
import { useNavigate } from "react-router-dom";

const validationSchema = yup.object({
  name: yup.string().required("Name  is required"),
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  property: yup.string().required("property is required"),
  contactNo: yup
    .string()
    .matches(
      /^[0-9]{10}$/,
      "Phone number must be 10 digits long and contain only numbers"
    )
    .required("Mobile number is required"),
});

const NewLandingPage = () => {
  const navigate = useNavigate();

  const divStyle = {
    backgroundImage: `url(${BackgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between", // Adding padding to the outer div
  };

  const [loading, setLoading] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [properties, setProperties] = useState([]);
  const [message, setMessage] = useState({});
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      address: "",
      property: "",
      contactNo: "",
      products: [],
    },
    validationSchema: validationSchema,

    onSubmit: async (values, { setSubmitting }) => {
      try {
        setLoading(true);

        let tempData = await apiData("post", API.enquiry, values);
        if (tempData.statusCode >= 200 && tempData.statusCode < 400) {
          navigate(`/congratulation/${coupon}`);
        }
        if (tempData.statusCode === 400) {
          setMessage({ status: "error", msg: "Email Already registered" });
          setOpen(false);
        }

        setTimeout(() => {
          window.location.reload();
        }, 3000);
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (err) {
      } finally {
        setLoading(false);
      }
    },
  });

  const handleInputChange = async (e) => {
    try {
      setLoading(true);
      setSearch(e.target.value);
      let tempData = await apiData("get", API.property, {
        query: e.target.value,
      });

      setProperties(tempData.data ? tempData.data : []);
    } catch (Err) {
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="main">
      <Header />
      {message && message.status && (
        <Alert severity={`${message.status}`}>
          <AlertTitle>{message.status}</AlertTitle>
          {message.msg && <>{message.msg}</>}
        </Alert>
      )}
      <Grid container spacing={2} className="content1" style={divStyle}>
        <div className="dummy">
          <div className="content">
            <p className="content-found">You Found Us!</p>
            {/* <p className="content-found1"> Us!</p> */}
            <p className="ccc-p">
              Please fill in some basic details and we will
            </p>
            <p className="ccc-p1">send you a unique code for some discounts</p>
            <p className="ccc-p2">on exciting new furniture.</p>
            <div className="socail">
              <Grid item={12} className="buttonContainer-landing">
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "rgb(255, 255, 255)",
                    fontSize: "20px",
                    color: "black",
                  }}
                  onClick={() => setOpen(true)}
                >
                  Get 10% Off
                </Button>
              </Grid>
              <div className="social-icons">
                <a
                  href="https://www.instagram.com/kaluinteriorsau/"
                  target="blank"
                  className="social-icon"
                >
                  <img
                    src={instagram}
                    style={{ height: "100%", width: "100%" }}
                  />
                </a>
                <a
                  href="https://www.facebook.com/share/8eVp3UeKUmubz8bf/?mibextid=qi2Omg"
                  target="blank"
                  className="social-icon"
                >
                  <img
                    src={facebook}
                    style={{ height: "100%", width: "100%" }}
                  />
                </a>
                <a
                  href="mailto:info@kaluinteriors.com.au"
                  target="blank"
                  className="social-icon"
                >
                  <img src={email} style={{ height: "100%", width: "100%" }} />
                </a>
                {/* <a href="#" className="social-icon">
                  <img
                    src={twitter}
                    style={{ height: "100%", width: "100%" }}
                  />
                </a> */}
              </div>
              <div className="email-id">
                <p>NEED HELP SETTING UP YOUR NEW HOME? ​</p>
                <p>DROP US AN EMAIL AT ​</p>
                <p>INFO@KALUINTERIORS.COM.AU</p>
              </div>
            </div>
          </div>

          <Grid container spacing={2} className="logo-section">
            <Grid item xs={6} className="kalu-logo2j">
              <img src={Secondimage} alt="Kalu Logo" />
            </Grid>
            <Grid item xs={6} className="kalu-logno3">
              <img src={rightSideImage} alt="Kalu Logo" />
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid container spacing={2} className="row1">
        <Grid item xs={12} ls={6} md={6} className="about-us">
          <br />
          <br />
          <div class=""></div>
          <div className="image-carousel">
            <div className="image-item">
              <img src={mainImage} alt="Image 1" />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} ls={6} md={6} className="explanation">
          <h1 className="let-us">Let Us Explain...</h1>
          <p>
            It is no accident you found this brochure and scanned that QR Code.
          </p>
          <p>
            We have created Kalu Interiors from running one of Melbourne's
            premier Home Styling Companies over the last 15 years.
          </p>
          <p>
            Our goal is to inspire you to get the best of your living spaces
            with a range of modern contemporary furniture designs.
          </p>
          <div className="find-out-button">
            <a
              href="https://www.kaluinteriors.com.au/pages/about-us"
              target="_blank"
            >
              <button className="find-out-more-button">FIND OUT MORE</button>
            </a>
          </div>
        </Grid>
      </Grid>
      <form className="LandingPgae" onSubmit={formik.handleSubmit}>
        <Dialog
          open={open}
          PaperProps={{ style: { borderRadius: "15px" } }}
          onClose={() => (
            <CloseIcon
              style={{ cursor: "pointer", textAlign: "right" }}
              onClick={() => setOpen(false)}
            />
          )}
        >
          <DialogContent dividers>
            <CloseIcon
              style={{
                position: "absolute",
                right: 2,
                top: 2,
                cursor: "pointer",
                color: "#dfdfdf",
              }}
              color="secondary"
              onClick={() => setOpen(false)}
            />

            <Grid container spacing={2}>
              <Grid item xs={12} className="formStyle">
                <h3 style={{ fontSize: "16px" }}>
                  Tell us where you saw our furniture to unlock your exclusive
                  10% discount!
                </h3>
                <Grid item xs={12} md={12} lg={12}>
                  <Box
                    component="form"
                    sx={{
                      "& .MuiTextField-root": { m: 1, width: "50ch" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      name="name"
                      type="text"
                      label="Name"
                      fullWidth
                      onChange={formik.handleChange}
                      error={formik.touched.name && Boolean(formik.errors.name)}
                      helperText={formik.touched.name && formik.errors.name}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    component="form"
                    sx={{
                      "& .MuiTextField-root": { m: 1, width: "50ch" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      name="email"
                      type="email"
                      label="Email"
                      fullWidth
                      onChange={formik.handleChange}
                      error={
                        formik.touched.email && Boolean(formik.errors.email)
                      }
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    component="form"
                    sx={{
                      "& .MuiTextField-root": { m: 1, width: "50ch" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      name="contactNo"
                      type="text"
                      label="Mobile Number"
                      fullWidth
                      onChange={formik.handleChange}
                      error={
                        formik.touched.contactNo &&
                        Boolean(formik.errors.contactNo)
                      }
                      helperText={
                        formik.touched.contactNo && formik.errors.contactNo
                      }
                    />
                  </Box>
                </Grid>
                <Grid className="dropdownList" item xs={12}>
                  <Box
                    component="form"
                    sx={{
                      "& .MuiTextField-root": { m: 1, width: "50ch" },
                    }}
                    noValidate
                    autoComplete="off"
                  >
                    <TextField
                      label="Which property did you see us in?"
                      name="property"
                      value={
                        formik.values.property === ""
                          ? search
                          : properties.find(
                              (item) => item._id === formik.values.property
                            ).address
                      }
                      onChange={handleInputChange}
                      error={
                        formik.touched.property &&
                        Boolean(formik.errors.property)
                      }
                      helperText={
                        formik.touched.property && formik.errors.property
                      }
                    />
                    {formik.values.property === "" && properties.length > 0 && (
                      <div className="productListSu">
                        {properties.map((suggestion) => (
                          <MenuItem
                            key={suggestion._id}
                            onClick={() => {
                              formik.setFieldValue("property", suggestion._id);

                              setCoupon(suggestion.coupon);
                            }}
                          >
                            {suggestion.address}
                          </MenuItem>
                        ))}
                      </div>
                    )}
                  </Box>
                </Grid>

                <Grid item={12} className="buttonContainer">
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#426e5a" }}
                    onClick={() => formik.handleSubmit()}
                    disabled={loading}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </form>
      <Footer />
    </div>
  );
};

export default NewLandingPage;
